module.exports = __webpack_public_path__ + "img/open_data.059151d6.png";